import { render, staticRenderFns } from "./add-edit-credentials-modal.vue?vue&type=template&id=2c63beea&scoped=true"
import script from "./add-edit-credentials-modal.vue?vue&type=script&lang=js"
export * from "./add-edit-credentials-modal.vue?vue&type=script&lang=js"
import style0 from "./add-edit-credentials-modal.vue?vue&type=style&index=0&id=2c63beea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c63beea",
  null
  
)

export default component.exports